const Marquee = () => {
  const items = [
    "Loft Conversions",
    "Luxury Bathrooms",
    "Bespoke Kitchens",
    "Full Refurbishments",
    "Architectural Extensions",
    "New Builds",
  ];
  return (
    <div
      data-testid="services-marquee"
      className="marquee-mask relative overflow-hidden border-y border-gold/15 bg-navy2 py-6"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((track) => (
          <div key={track} aria-hidden={track === 1} className="flex items-center">
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-xl font-medium tracking-wide text-white/60 md:text-2xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
